<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>资金管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="showInUserList">外包平台</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section v-show="!hideInUserEdit && !hideInAddShow">
      <section class="searchBoxTwo">
        <span class="addStyle">
          <a-button
            type="primary"
            icon="plus"
            @click="hideInAddShow = !hideInAddShow"
            >增加</a-button
          >
        </span>
        <span class="searchStyle">
          <a-input
            v-model="query_field"
            style="margin-right:20px;"
            placeholder="请输入外包平台名称"
          />
          <a-button @click="onReset" style="margin-right:10px">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data == ''">
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>{{ item.name }}</td>
              <td>{{ Number(item.rate) + "%" }}</td>
              <td>{{ item.create_time }}</td>
              <td>{{ item.update_time }}</td>
              <td class="operation">
                <a style="color:#67c23a" @click="edit(item)">编辑</a>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 新增 -->
    <addPlatform v-if="hideInAddShow" v-on:hideInAdd="hideInAdd" />
    <!-- 新增 end -->
    <!-- 编辑 -->
    <platformEdit
      v-show="hideInUserEdit"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑 end-->
  </div>
</template>
<script>
import axios from "axios";
import addPlatform from "@/components/money/addPlatform"; //新增保洁
import platformEdit from "@/components/money/platformEdit"; //编辑保洁
export default {
  components: {
    platformEdit,
    addPlatform
  },
  data() {
    return {
      data: {},
      loading: false,
      page: 1,
      pagination: {},
      hideInAddShow: false,
      query_field: "",
      hideInUserEdit: false,
      editDetail: {},
      totalPage: Number,
      thList: ["外包平台", "费率", "创建时间", "更新时间", "操作"]
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    onReset() {
      this.query_field = "";
      this.page = 1;
      this.getData();
    },
    cleanSystem() {
      let routeUrl = this.$router.resolve({
        path: "/clean/cleanHouse"
      });
      window.open(routeUrl.href, "_blank");
    },
    onChange(pageNumber) {
      //   console.log("Page: ", pageNumber);
      this.page = pageNumber;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    hideInAdd(msg) {
      this.hideInAddShow = msg;
      this.reload();
    },
    hideInEdit(msg) {
      this.hideInUserEdit = msg;
      this.reload();
    },
    showInUserList() {
      this.hideIsWorker = false;
      this.hideInUserEdit = false;
      this.hideInAddShow = false;
    },
    onSearch(value) {
      this.page = 1;
      // this.query_field = value;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.data = [];
      let url =
        this.httpsBasic.url +
        this.httpsBasic.finance +
        "Finance_platform/lists";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    edit(detail) {
      this.hideInUserEdit = true;
      this.editDetail = detail;
    },
    detailPage(detail) {
      this.hideIsWorker = true;
      this.detail = detail;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
</style>
<style lang="less">
.ant-table {
  min-height: 58vh;
}
</style>
